var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapOpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 -0.5 17 17",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    transform: "translate(-0.5,0.522)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.502 16.489H5.845v-2.892h-.85l3.506-2.396 3.504 2.396h-.85v2.892z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.0223403
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapOpt);
export default __webpack_public_path__ + "static/media/cap_opt.3514cd26f81ab652b343357130d67369.svg";
export { ForwardRef as ReactComponent };